<template>
  <div class='desc'>
    <div class="list">
      <div class='left'>
        <h2>{{ trainData.train_Name }}</h2>
        <p>{{ trainData.train_desc }}</p>
      </div>
      <div class='right'>
        <div class='btn' @click="bindDD()">完成培训后解锁{{ trainData.menue_name }}</div>
        <img :src="trainData.train_img_desc" alt=""/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'guide-desc',
  data(){
    return{
      item: [],
      tabName: '采购中心',
    }
  },
  props: {
    dingTalkStatus: {
      type: Number,
      default: 0
    },
    trainData: {
      type: Object,
      default: () => {}
    },
    sideSubMenuItem: {
      type: Object,
      default: () => {}
    },
  },
  methods: {
    bindDD() {
      const { dingTalkStatus } = this;
      console.log(dingTalkStatus,'dingTalkStatus bindDD');
      if(!dingTalkStatus){
        this.$emit('bindDD', 2);
      } else {
        this.$emit('bindDD', 1);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .desc{
    color: #333333;
    background: #fff;
    // height: 95px;
    border-radius: 8px;
    text-align: center;
    h2{
      font-size: 26px;
      font-weight: 500;
      margin: 0 auto 16px;
      padding-top: 32px;
    }
    p{
      font-weight: 400;
      font-size: 20px;
    }
    .list{
      position: relative;
      .right{
        .btn{
          text-align: center;
          width: 372px;
          background: #F4840F;
          color: #fff;
          box-shadow: 0px 0px 4px 0px rgba(244,132,15,0.4600);
          border-radius: 49px;
          font-size: 22px;
          margin: 24px auto 35px;
          padding: 19px 0;
          cursor: pointer;
          &:hover{
            opacity: .8;
          }
        }
        p{
          width: 100%;
          margin-top: 46px;
        }
        img{
          display: block;
          width: 100%;
        }
      }
    }
  }
</style>